const DEFAULT_API_BASE_URL = ''

export const getApiBaseUrl = () => {
  const fromEnv = import.meta.env?.VITE_API_BASE_URL

  // If env variable is explicitly set (even if empty), use it
  // Empty string means use Vite proxy
  if (typeof fromEnv === 'string') {
    return fromEnv.replace(/\/$/, '')
  }

  // Default to empty => use Vite dev server proxy for /api
  return DEFAULT_API_BASE_URL
}

export const withApiBaseUrl = (path = '') => {
  const base = getApiBaseUrl()
  if (!path) return base
  if (/^https?:\/\//i.test(path)) {
    return path
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${base}${normalizedPath}`
}

export default {
  getApiBaseUrl,
  withApiBaseUrl,
}
